import { render } from "./ClientApp.vue?vue&type=template&id=21ad1bd4&scoped=true"
import script from "./ClientApp.vue?vue&type=script&lang=js"
export * from "./ClientApp.vue?vue&type=script&lang=js"

import "./ClientApp.vue?vue&type=style&index=0&id=21ad1bd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21ad1bd4"

export default script